import { LegalPage } from "@/components/LegalPage";

const sections = [
  {
    h: "Acceptance of Terms",
    p: [
      "These Terms of Service (\"Terms\") govern your access to and use of the websites, dashboards and payment services provided by Elikya Technology, Inc. (\"Elikya\", \"we\", \"us\"). By creating an account or using the service, you agree to these Terms. If you are using the service on behalf of a business, you represent that you are authorised to bind that business.",
    ],
  },
  {
    h: "Description of Service",
    p: [
      "Elikya provides payment infrastructure that helps businesses accept payments, automate billing and settle funds across supported markets and rails. Features and availability may vary by region and may change over time as we improve the platform.",
    ],
  },
  {
    h: "Eligibility",
    p: [
      "You must be at least 18 years old and capable of forming a binding contract to use the service. The service is intended for businesses and their authorised representatives.",
    ],
  },
  {
    h: "Accounts and Registration",
    p: [
      "You are responsible for providing accurate information, keeping your credentials secure and for all activity that occurs under your account. Notify us promptly of any unauthorised use. We may suspend or terminate accounts that violate these Terms or present risk to the platform.",
    ],
  },
  {
    h: "Acceptable Use",
    p: ["You agree not to use the service to:"],
    list: [
      "Break any applicable law, regulation or payment-network rule.",
      "Facilitate fraud, money laundering or prohibited transactions.",
      "Interfere with, probe or disrupt the security or integrity of the platform.",
      "Infringe the intellectual property or privacy rights of others.",
    ],
  },
  {
    h: "Fees and Payments",
    p: [
      "Fees for the service are described in your agreement or pricing in effect at the time of use. Applicable processing fees may be deducted from settlements. Unless stated otherwise, fees are exclusive of taxes, which you are responsible for where required.",
    ],
  },
  {
    h: "Intellectual Property",
    p: [
      "The service, including its software, design, trademarks and content, is owned by Elikya Technology and its licensors and is protected by intellectual property laws. We grant you a limited, non-exclusive, non-transferable right to use the service in accordance with these Terms. Girdercore, NightOwl and Zando are products of Elikya Technology, Inc.",
    ],
  },
  {
    h: "Third-Party Services",
    p: [
      "The service may integrate with banks, mobile money networks, card schemes and other third parties. Your use of those services may be subject to their own terms, and we are not responsible for third-party services outside our control.",
    ],
  },
  {
    h: "Disclaimers",
    p: [
      "The service is provided \"as is\" and \"as available\" without warranties of any kind, whether express or implied, including fitness for a particular purpose and non-infringement, to the fullest extent permitted by law. We do not warrant that the service will be uninterrupted or error-free.",
    ],
  },
  {
    h: "Limitation of Liability",
    p: [
      "To the maximum extent permitted by law, Elikya and its affiliates will not be liable for any indirect, incidental, special, consequential or punitive damages, or any loss of profits or revenues, arising from your use of the service. Our aggregate liability for any claim will not exceed the fees you paid to us in the three months preceding the claim.",
    ],
  },
  {
    h: "Indemnification",
    p: [
      "You agree to indemnify and hold harmless Elikya, its affiliates and personnel from any claims, damages, liabilities and expenses arising out of your use of the service, your content, or your breach of these Terms or applicable law.",
    ],
  },
  {
    h: "Governing Law",
    p: [
      "These Terms are governed by the laws of the State of Delaware, United States, without regard to its conflict-of-laws principles. The courts located in Delaware will have exclusive jurisdiction over any dispute arising from these Terms, subject to any mandatory local requirements in the regions where we operate.",
    ],
  },
  {
    h: "Changes to These Terms",
    p: [
      "We may update these Terms from time to time. When we make material changes, we will update the \"Last updated\" date above and, where appropriate, provide additional notice. Your continued use of the service after changes take effect constitutes acceptance of the updated Terms.",
    ],
  },
  {
    h: "Contact Us",
    p: [
      "Questions about these Terms? Contact us at hello@elikya.tech. Elikya Technology, Inc., Newark, Delaware, United States.",
    ],
  },
];

const Terms = () => (
  <LegalPage
    title="Terms of Service"
    updated="January 1, 2026"
    description="The terms that govern your use of Elikya Technology's websites, dashboards and payment services."
    path="/terms"
    intro="Please read these Terms of Service carefully. They set out the rules for using Elikya Technology's websites and payment services."
    sections={sections}
  />
);

export default Terms;
